import React from 'react';
import { ArrowRight } from 'lucide-react';
import { TRENDING, BRAND } from '../mock/mock';

export default function TrendingRecipes() {
  return (
    <section id="recipes" className="py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase font-semibold mb-2" style={{ color: 'var(--gk-gold-dark)' }}>• Kitchen Diaries •</div>
            <h2 className="section-title text-3xl md:text-4xl">Trending Seasonal Recipes</h2>
          </div>
          <a href="#" className="link-underline text-sm font-semibold inline-flex items-center gap-2" style={{ color: 'var(--gk-green-dark)' }}>View All <ArrowRight size={14} /></a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {TRENDING.map(t => (
            <a key={t.id} href="#" className="group block">
              <div className="aspect-[4/5] rounded-xl overflow-hidden mb-4 relative">
                <img src={t.img} alt={t.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, transparent 55%, rgba(45,58,26,0.7) 100%)' }} />
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-serif text-xl font-bold text-white leading-tight">{t.title}</h3>
                </div>
              </div>
              <span className="link-underline text-sm font-semibold" style={{ color: 'var(--gk-terracotta)' }}>View Recipe →</span>
            </a>
          ))}
        </div>
      </div>

      {/* Story 3 columns */}
      <div id="story" className="mt-20" style={{ background: 'var(--gk-green-dark)' }}>
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-20 grid md:grid-cols-3 gap-10">
          {[
            { title: 'Our Story', desc: 'Discover why every jar of Gaon Ke Masale carries the taste of Indian villages — hand-picked, hand-milled and shipped fresh.', cta: 'Why Us' },
            { title: 'Our Recipes', desc: 'From dadi’s dum biryani to that one perfect chai, see how our masalas fit into the recipes families cook every day.', cta: 'Explore Recipes' },
            { title: 'Our Media', desc: 'See where Gaon Ke Masale has been featured — food journals, television kitchens and celebrated chef reviews.', cta: 'Watch Now' },
          ].map((s, i) => (
            <div key={i} className="text-center border-t md:border-t-0 md:border-l first:border-none pt-8 md:pt-0 md:pl-10 first:pl-0" style={{ borderColor: 'rgba(201,169,97,0.25)' }}>
              <h3 className="font-serif text-3xl font-bold mb-4" style={{ color: 'var(--gk-gold)' }}>{s.title}</h3>
              <p className="text-sm md:text-base leading-relaxed mb-6" style={{ color: '#e6dfc9' }}>{s.desc}</p>
              <a href="#" className="inline-block px-6 py-2.5 rounded-full text-sm font-semibold" style={{ border: '1.5px solid var(--gk-gold)', color: 'var(--gk-gold)' }}>{s.cta}</a>
            </div>
          ))}
        </div>
      </div>

      {/* Passion strip */}
      <div className="mt-0" style={{ background: 'var(--gk-cream-dark)' }}>
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 grid md:grid-cols-2 gap-10 items-center">
          <img src={BRAND.bowl} alt="Village spice art" className="rounded-2xl w-full" />
          <div>
            <div className="text-xs tracking-[0.3em] uppercase font-semibold mb-3" style={{ color: 'var(--gk-gold-dark)' }}>• The Art of Gaon Blending •</div>
            <h2 className="section-title text-3xl md:text-4xl mb-4">A passion for pure, farm-to-kitchen spices.</h2>
            <p className="text-base leading-relaxed mb-4" style={{ color: 'var(--gk-ink)' }}>Every batch begins with farmers we know by name. From the terraces of Wayanad to the hills of Meghalaya, we work directly with growers who still sun-dry their spices the traditional way.</p>
            <p className="text-base leading-relaxed" style={{ color: 'var(--gk-muted)' }}>The result is masala with an aroma you can actually smell before opening the jar — the way a grandmother’s kitchen always did.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
